import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import HistoricModal, {
  HISTORIC_COLUMNS
} from '@component/Parameterization/Shared/HistoricModal'

import ParametroCompra from '@service/ParametroCompra'

const ModalHistoricPurchaseUser: FC = () => {
  const { companieId } = useParametrizationConfigPurchase()
  return (
    <HistoricModal
      title="Histórico Compradores"
      empresaId={companieId}
      fetcher={async empresaId =>
        (await ParametroCompra.getUsuarioComprasHistorico(empresaId)).data
          ?.data ?? []
      }
      columns={[
        HISTORIC_COLUMNS.data,
        HISTORIC_COLUMNS.usuario,
        HISTORIC_COLUMNS.empresa,
        HISTORIC_COLUMNS.acao
      ]}
      emptyMessage="Nenhum histórico de compradores encontrado para esta empresa."
    />
  )
}

export default ModalHistoricPurchaseUser
